// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface NextIconSignature {
  Element: SVGSVGElement;
}

export const NextIcon: TOC<NextIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path fill-rule="evenodd" clip-rule="evenodd" d="M20 3H18C16.897 3 16 3.896 16 5V19C16 20.103 16.897 21 18 21H20C21.103 21 22 20.103 22 19V5C22 3.896 21.103 3 20 3ZM6.228 5.466L12.599 10.422C13.09 10.804 13.371 11.379 13.371 12C13.371 12.621 13.09 13.196 12.6 13.578L6.228 18.535C5.627 19.002 4.813 19.09 4.121 18.752C3.44 18.418 3 17.713 3 16.955V7.045C3 6.287 3.44 5.582 4.121 5.249C4.788 4.922 5.639 5.008 6.228 5.466ZM11.372 12L5 7.045V16.955L11.372 12ZM20 5H18V19H20.001L20 5Z"/>
</svg>
</template>;